import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import {
	ContactService,
	ClassificationService,
	PricelistService
} from '../../services/index';
import { Contact, SelectItem } from '../../models/index';

import { LazyLoadEvent, Message, MenuItem } from 'primeng/primeng';

@Component({
  selector: 'app-contact-table',
  templateUrl: './contact-table.component.html',
  styleUrls: ['./contact-table.component.scss'],
  animations: []
})
export class ContactTableComponent implements OnInit {
	@Input('company') companyId: number;

	contacts: Array<Contact> = [];
	totalContacts: number = 0;

	showLoadingError: boolean = false;
	loadingContacts: boolean = false;

	lastEvent: LazyLoadEvent;

	classifications: SelectItem[] = [];

	selectedContact: Contact;
	cmItems: MenuItem[];

	constructor(
		private router: Router,
		private translate: TranslateService,
		private contactService: ContactService,
		private classService: ClassificationService,
		private pricelistService: PricelistService
	) {}

	ngOnInit()
	{
		this.translate.get(['View', 'Add Offer', 'Delete']).subscribe(res => {
	        this.cmItems = [
	            {label: res['View'], icon: 'fa-search', command: (event) => this.router.navigate(['/crm/contact', this.selectedContact.id])},
	            {label: res['Add Offer'], icon: 'fa-plus', command: (event) => this.router.navigate(['/crm/contact', this.selectedContact.id, 'newoffer'])},
	            {label: res['Delete'], icon: 'fa-close', command: (event) => this.deleteContact(this.selectedContact)}
			];
		});
		
		this.classifications = this.classService.selectItemArray();

		//this.loadContacts();

		/*this.contactService.get().subscribe(data => {
			this.contacts = data.data;
			this.totalContacts = data.total;

			this.showLoadingError = false;
			this.loadingContacts = false;
		}, err => {
			this.showLoadingError = true;
			this.loadingContacts = false;
		});*/
	}

	loadContacts(event?: LazyLoadEvent)
	{
		if(!event) {
			event = this.lastEvent;
		}

		if(!event) {
			this.showLoadingError = true;
			return;
		}

		this.lastEvent = event;

		if(this.companyId) {
			event.filters.company_id = {
				matchMode: 'equal',
				value: this.companyId
			};
		}

		this.contactService.getLazy(event).subscribe(data => {
			this.contacts = data.data;
			this.totalContacts = data.total;

			this.showLoadingError = false;
			this.loadingContacts = false;
		}, err => {
			this.showLoadingError = true;
			this.loadingContacts = false;
		});
	}

	deleteContact(contact: Contact): void {
		this.contactService.delete(contact.id).subscribe(response => {
			this.loadContacts();
		});
		/*this.confirmationService.confirm({
			message: this.translate.instant("Are you sure?"),
			header: this.translate.instant("Delete Contact"),
			icon: 'fa fa-trash',
			accept: () => {
				this.contactService.delete(contact.id).subscribe(response => {
					if(response.success) {
						this.messageService.add({severity: 'success', summary: this.translate.instant("Delete Contact"), detail: this.translate.instant("Contact successfully deleted")});
					} else {
						let error = (response.error ? response.error : this.translate.instant("Unknown error occured"));
						this.messageService.add({severity: 'danger', summary: this.translate.instant("Delete Contact"), detail: error});
					}

					this.loadContacts();
				});
			},
			reject: () => {}
		});*/
	}

	onRowDblclick(event) {
		this.router.navigate(['/crm/contact', event.data.id])
	}

	/*loadContacts(event: LazyLoadEvent) {
		if(this.loadingContacts) {
			return;
		}
		this.loadingContacts = true;

		this.contactService.get().subscribe(data => {
			this.contacts = data.data;
			this.showLoadingError = false;
			this.loadingContacts = false;
		}, err => {
			this.showLoadingError = true;
			this.loadingContacts = false;
		});
	}*/

}



// WEBPACK FOOTER //
// /var/www/vhosts/vinologiwijnen.nl/httpdocs/crm/resources/assets/src/app/shared/modules/contact-table/contact-table.component.ts